import {makeStyles} from 'tss-react/mui'
export const useLayoutStyles = makeStyles()(() => ({
  tableCell1: {
    width: '280px'
  },
  tableCell2: {
    width: '280px'
  },
  tableCell3: {
    width: '180px'
  },
  tableCell4: {
    width: '200px'
  },
  cursorPointer: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '16px'
  },
  fullWidth: {
    gridColumn: '1 / -1'
  },
  sideCardHeader: {
    paddingBottom: '20px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',

    '& h3': {
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    }
  },
  sideCardHeaderCompact: {
    paddingBottom: '8px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',

    '& h3': {
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      wordBreak: 'break-word'
    }
  },
  invisibleScrollbar: {
    overflow: 'scroll',
    height: 'calc(100vh - 285px)',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  createNewInsightButton: {
    marginTop: '-8px',
    marginBottom: '16px'
  }
}))
